/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — Decision/Insights — RTK Query slice. Company-wide
   "where the business needs a decision" rollup: closed customers by lens,
   onboarding TAT, brand momentum, Sales POC performance.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get } from '../common/constants'

const DECISION_INSIGHTS = apiConstants.GROWTHOS_ADMIN_DECISION_INSIGHTS

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosDecisionInsightsApiSlice = createApi({
  reducerPath: 'growthosDecisionInsightsApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['DecisionInsights'],
  endpoints: (b) => ({
    getDecisionInsights: b.query({
      queryFn: ({ period, from, to }) => run(get(DECISION_INSIGHTS, { period, from, to })),
      providesTags: ['DecisionInsights'],
    }),
  }),
})

export const { useGetDecisionInsightsQuery } = growthosDecisionInsightsApiSlice
